export interface FaqItem {
  question: string
  answer: string
}

export const faq: FaqItem[] = [
  {
    question: 'How do I access the material?',
    answer: 'You receive instant digital access after completing your purchase.',
  },
  {
    question: 'Is it a subscription?',
    answer: 'No. It is a one-time purchase.',
  },
  {
    question: 'Do I need to be an orthodontist?',
    answer:
      'ALIGNER CASE COMMANDER™ is designed as an educational workflow organization system for dental professionals who work with aligner cases. Its suitability depends on your professional training and scope of practice.',
  },
  {
    question: 'Is this a course?',
    answer:
      'No. It is a visual case organization system containing six volumes, trackers, checklists, maps, review tools, and printable resources.',
  },
  {
    question: 'Is it a PDF?',
    answer:
      'The system is delivered digitally and includes printable resources designed for practical use.',
  },
  {
    question: 'Does it include all 6 volumes?',
    answer: 'Yes. The $27 offer includes all six volumes plus all five bonuses.',
  },
  {
    question: 'Can I use it for different aligner cases?',
    answer:
      'The templates are designed to help organize different cases and stages of an aligner workflow. They are organizational and educational tools, not individualized clinical treatment plans.',
  },
  {
    question: 'What if it’s not for me?',
    answer: 'You have a 7-day guarantee according to the terms of the offer.',
  },
]
